import { useParams } from "react-router";
import MainLayout from "@/components/layouts";
import { PageHeader } from "@/components/layouts/page-header/index.tsx";
import { usePhotoWorkflow } from "./photo-workflow.hooks";
import { DndContext, closestCenter, PointerSensor, KeyboardSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import SortableCard from "./photo-workflow.components/sortable-card";
import AddPhotoWorkflowModal from "./photo-workflow.components/add-item";
import DeletePhotoWorkflowModal from "./photo-workflow.components/delete-item";

export default function ServicesPhotoWorkflow() {
  const { id } = useParams();
  const {
    list,
    handleDragEnd,
    addDialog,
    setAddDialog,
    createPhotoWorkflowItem,
    handleDeleteOpen,
    setDelDialog,
    delDialog,
    deletePhotoWorkflowItem,
  } = usePhotoWorkflow(id as string);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <MainLayout breadcrumb={[{ name: "Services", href: "#" }]}>
      <PageHeader
        title="Photo Workflow"
        subtitle="Manage your photo workflow"
        buttonText="Add New"
        onButtonClick={() => setAddDialog(true)}
      />
      <div className="container mx-auto">
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={list.map((i) => i.id)} strategy={verticalListSortingStrategy}>
            {list.map((item) => (
              <SortableCard key={item.id} item={item} handleDelete={() => handleDeleteOpen(item.id)} />
            ))}
          </SortableContext>
        </DndContext>
      </div>

      <AddPhotoWorkflowModal open={addDialog} setOpen={setAddDialog} onSubmit={createPhotoWorkflowItem} />
      <DeletePhotoWorkflowModal open={delDialog} setOpen={setDelDialog} handleDelete={deletePhotoWorkflowItem} />
    </MainLayout>
  );
}
